<template>
  <div>
    <nuxt-link to="/" class="logo navbar-item"> Pedalsure. </nuxt-link>
    <!-- <div>MTA LAYOUT</div> -->
    <nuxt />
    <CongratsModal />
    <MtaPaymentModal />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
import MtaPaymentModal from '@/components/modals/MtaPayment'
import CongratsModal from '@/components/modals/Congrats'
import BuildBadge from '@/components/common/BuildBadge'

import { buildSeoHead } from '@/helpers/seo'

export default {
  components: {
    BuildBadge,
    MtaPaymentModal,
    CongratsModal,
  },
  middleware: ['load-public-quote'],
  head() {
    return {
      bodyAttrs: {
        class: 'has-navbar-fixed-bottom',
      },
      style: [
        { cssText: this.$store.getters['theme/theme'], type: 'text/css' },
      ],
      // Canonical + noindex for every page using this layout — see
      // helpers/seo.js.
      ...buildSeoHead(this.$route.path),
    }
  },
  mounted() {
    this.$store.dispatch('quote/setMtaFlag', true)
  },
}
</script>

<style lang="scss" scoped>
.logo {
  font-size: 30px;
  color: $ps-primary;
}
</style>
